export default {
	name: 'donationProducts',
	component(props) {
		const { productIds } = props

		return {
			init() {
				if (!productIds?.length) {
					this.removeDonationProducts()
				}
			},

			getDonationProductsInCart() {
				const items = window.liquidAjaxCart.cart.items
				const donationProductsLineItems = items.filter(item => productIds.includes(item.product_id))
				return donationProductsLineItems
			},

			removeDonationProducts() {
				const donationProductsLineItems = this.getDonationProductsInCart()
				if (donationProductsLineItems.length) {
					donationProductsLineItems.forEach(item => {
						window.liquidAjaxCart.change({ id: item.key, quantity: 0 })
					})
				}
			},

			selectDonationProduct(variantId) {
				const donationProductsInCart = this.getDonationProductsInCart()
				if (donationProductsInCart.length) {
					const payloadToRemove = donationProductsInCart.reduce((acc, item) => {
						acc[item.variant_id] = 0
						return acc
					}, {})
					const payloadToAdd = {
						[variantId]: 1
					}
					const updates = { ...payloadToRemove, ...payloadToAdd }
					window.liquidAjaxCart.update({ updates })
				} else {
					window.liquidAjaxCart.add({
						items: [
							{
								id: variantId,
								quantity: 1,
								price: 0
							}
						]
					})
				}
			}
		}
	}
}
